import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Col, Form, Input, Modal, Row, message } from "antd";
import { useEffect } from "react";
import { updateVehiclePrice } from "../../../../api/vehicles";

export default function UpdatePrice({
  isVisible,
  setVisible,
  vehicle,
  vehicleId,
}: any) {
  const { id, price } = vehicle;

  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: updateVehiclePrice,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["vehicles", vehicleId] });
      setVisible(false);
    },
  });

  const onSubmit = async () => {
    const { price } = await form.validateFields();
    const data = {
      price: Number(price),
    };
    mutate({ id, data });
  };

  useEffect(() => {
    form.setFieldsValue({ ...vehicle });
  }, [vehicle]);

  return (
    <Modal
      title="Update Price"
      open={isVisible}
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="UpdateVehiclePrice"
          htmlType="submit"
          onSubmit={onSubmit}
          loading={isLoading}
          className="border-0 bg-blue-600 text-white"
        >
          Update
        </Button>,
      ]}
    >
      <div className="">
        <Form
          id="UpdateVehiclePrice"
          form={form}
          name="control-ref"
          onFinish={onSubmit}
          layout="vertical"
        >
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <Form.Item
                name="price"
                label="Price Exclusive ( TZS )"
                initialValue={price}
                rules={[
                  {
                    required: true,
                    message: "Please enter vehicle price",
                  },
                ]}
              >
                <Input placeholder="Price Exclusive ( TZS )" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
}
